import { usePunditUserContext } from "@circle-react/contexts";

export const useSupportUnreleasedWorkflowsFeaturesEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(
    currentCommunitySettings?.support_unreleased_workflows_features_enabled,
  );
};
